module.exports = __webpack_public_path__ + "img/machine_white.efa5dfe1.svg";